import * as api from '../../api';
import { pagingDataUtilities } from '../../common';
import { participantTypeHelpers } from '../../participant-types';

export const fetchListActions = api.fetchActions('unregistered-participants', 'fetch-unregistered-participants');
export const registerParticipantActions = api.fetchActions('unregistered-participants', 'register-participants');
export const pagingActions = pagingDataUtilities.pagingActions('unregistered-participants', 'paging');

export const actionTypes = {
  ...fetchListActions.actionTypes,
  ...pagingActions.actionTypes,
  ...registerParticipantActions.actionTypes,
  CLEAR_PARTICIPANTS_TO_REGISTER : 'unregistered-participants.clear-participants-to-register',
  SELECT_PARTICIPANT : 'unregistered-participants.select-participant',
  SELECT_ALL_PARTICIPANTS : 'unregistered-participants.select-all-participant',
  SET_SEARCH_TEXT : 'registered-participants.set-search-text',
  START_SEARCH : 'registered-participants.start-search',
  RESTRICT_AUDIT_DATE : 'registered-participants.restrict-audit-date',
  UNRESTRICT_AUDIT_DATE : 'resistered-participants.unrestrict-audit-date',
  CLOSE_CONFIRM_MODAL : 'unregistered-participants.close-confirm-modal',
  SHOW_CONFIRM_MODAL : 'unregistered-participants.show-confirm-modal',
  SET_SELECTED_SAVE_OPTION : 'unregistered-participants.set-selected-save-option'
};

export function fetchList() {
  return (dispatch, getState) => {
    const state = getState();
    const { unregisteredParticipants } = state;
    const { pagingData, searchQuery, auditDateRestricted } = unregisteredParticipants;
    const { currentPage, itemsPerPage, sortBy, sortAsc } = pagingData || {};
    const { sites } = state;
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      registered : false,
      page: currentPage,
      perPage: itemsPerPage,
      sortBy,
      sortAsc,
      search: searchQuery,
      lastAuditDate: auditDateRestricted,
      siteId: sites && sites.selectedSiteId,
      programId: sites && sites.selectedProgramId
    };
    return dispatch(api.shouldExecute(['unregisteredParticipants', 'listState'], api.getThunk(`/participants`, params, fetchListActions)));
  }
}

export const changePageNumber = (page) => pagingDataUtilities.changePage(page, pagingActions);
export const changeSort = (newSort) => pagingDataUtilities.changeSort(newSort, pagingActions, ['unregisteredParticipants', 'pagingData']);
export const changeResultsPerPage = (perPage) => pagingDataUtilities.changePerPage(perPage, pagingActions, ['unregisteredParticipants', 'pagingData']);

/**
 * Grant portal access to the provided list of participants
 * @param {*} externalIds : list of external guids to register for portal access
 */
export function registerParticipants(externalIds) {
  return (dispatch, getState) => {
    const params = {
      participantTypeId: participantTypeHelpers.getParticipantTypeId(),
      externalIds: externalIds
    }
    return dispatch(
      api.shouldExecute(
        ['unregisteredParticipants', 'registrationState'],
        api.postThunk(`/participants/batch`, params, registerParticipantActions)
      )
    );
  }
}

export function clearParticipantsToRegister() {
  return {
    type : actionTypes.CLEAR_PARTICIPANTS_TO_REGISTER,
  }
}

export function selectParticipant(id, status) {
  return {
    type : actionTypes.SELECT_PARTICIPANT,
    id,
    status
  }
}


export function selectAllParticipants() {
  return {
    type : actionTypes.SELECT_ALL_PARTICIPANTS
  }
}

export function setSearchText(text) {
  return {
    type : actionTypes.SET_SEARCH_TEXT,
    text
  }
}

export function startSearch() {
  return {
    type : actionTypes.START_SEARCH
  }
}

export function restrictAuditDate(auditDate) {
  return {
    type : actionTypes.RESTRICT_AUDIT_DATE,
    auditDate
  }
}

export function unrestrictAuditDate() {
  return {
    type : actionTypes.UNRESTRICT_AUDIT_DATE
  }
}

export function closeConfirmModal() {
  return {
    type: actionTypes.CLOSE_CONFIRM_MODAL,
  }
}

export function showSubmitConfirmModal() {
  return {
    type: actionTypes.SHOW_CONFIRM_MODAL,
  }
}

/**
 * This action method is called whenever the admin selects a radio button option to search by site/program or by lname/email.
 * It updates the store with the radio button value and this value is used in the search component to display the sites/programs
 * dropdownlist or display the text area
 * @param {guid} value : value of the radiobutton element
 */
export function setSelectedSaveOption(value) {
  return {
    type: actionTypes.SET_SELECTED_SAVE_OPTION,
    value
  }
}
